"use client";

import * as Components from "@components";
import { Home, New, News, Pricing, Profile, Scam, Sniper, Support, Whale } from "@pages";
import Deploy from "@pages/Deploy";
import MemeSwap from "@pages/MemeSwap";
import Mint from "@pages/Mint";
import Swap from "@pages/Swap";
import { useWallet } from "@stores/wallet.store";
import { useTonConnectUI } from "@tonconnect/ui-react";
import { type FC, useEffect } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { useShallow } from "zustand/react/shallow";

const REFERRAL_CODE_KEY = "referral_code";

const App: FC = () => {
    const { pathname, search } = useLocation();
    const navigate = useNavigate();
    const isAuth = useWallet(useShallow((state) => state.isConnected));
    const getWallets = useWallet(useShallow((state) => state.getWallets));
    const fetchReferrals = useWallet(useShallow((state) => state.fetchReferrals));
    const [tonConnectUI] = useTonConnectUI();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    useEffect(() => {
        const searchParams = new URLSearchParams(search);
        const refCode = searchParams.get("ref");

        if (refCode) {
            localStorage.setItem(REFERRAL_CODE_KEY, refCode);

            searchParams.delete("ref");
            const newUrl = searchParams.toString() ? `${pathname}?${searchParams.toString()}` : pathname;

            window.history.replaceState({}, "", newUrl);
        }
    }, [search, pathname]);

    useEffect(() => {
        tonConnectUI.connector.restoreConnection();
    }, []);

    useEffect(() => {
        if (!["/", "/mint", "/pricing"].includes(pathname) && !isAuth) {
            navigate("/");
            return;
        }
        async function updateWallets() {
            fetchReferrals();
            getWallets();
        }

        if (isAuth) {
            updateWallets();
        } else if (!tonConnectUI.connected && isAuth) {
        }
    }, [isAuth, tonConnectUI.connected]);

    return (
        <>
            <Components.SuccessTransaction />
            <Components.ErrorTransaction />
            <Components.WarningTransaction />
            <Components.PendingTransaction />
            <Components.Connect />
            <Components.Create isVisible={false} setIsVisible={() => {}} />

            <Routes>
                <Route path="/" element={<Components.LandingLayout />}>
                    <Route index element={<Home />} />
                    <Route path="mint" element={<Mint />} />
                    <Route path="pricing" element={<Pricing />} />
                    <Route path="news">
                        <Route index element={<News />} />
                        <Route path=":id" element={<New />} />
                    </Route>
                    <Route path="support" element={<Support />} />
                </Route>
                <Route path="/" element={<Components.MainLayout />}>
                    <Route path="memeswap" element={<MemeSwap />} />
                    <Route path="profile" element={<Profile />} />
                    <Route path="swap" element={<Swap />} />
                    <Route path="sniper" element={<Sniper />} />
                    <Route path="scam" element={<Scam />} />
                    <Route path="whale" element={<Whale />} />
                    <Route path="deploy" element={<Deploy />} />
                </Route>
            </Routes>
        </>
    );
};

export default App;
